import { OrderCriteria } from '@nemuru-eng/js-api-client';

import { OrderCriteriaStatusTag } from '@/components/shared/components/OrderCriteriaStatusTag/OrderCriteriaStatusTag';
import { Text } from '@/components/shared/components/Text';

export const orderStatusFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'order_status_value',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData: { row: OrderCriteria }) => (
      <div
        style={{
          minWidth: '120px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          whiteSpace: 'break-spaces',
          width: '100%',
        }}
      >
        <OrderCriteriaStatusTag orderCriteria={rowData.row} />
      </div>
    ),
  };
};
